import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";

export const BrandingSkipped = () => {
  const { t } = useTranslation();

  return (
    <div className="p-12 bg-white/50 rounded-3xl border border-black/5 text-center space-y-6">
      <div className="w-24 h-24 rounded-full bg-black/5 flex items-center justify-center mx-auto mb-4">
        <Check className="w-12 h-12 text-black/20" />
      </div>
      <div className="space-y-2">
        <h3 className="text-3xl 2k:text-5xl 4k:text-7xl font-bold">
          {t("createVideo.watermarkSkipped") || "All Set!"}
        </h3>
        <p className="text-muted-foreground max-w-md mx-auto 2k:text-2xl 4k:text-4xl">
          {t("createVideo.watermarkSkippedDesc") ||
            "Everything is ready. You can now proceed to create your video."}
        </p>
      </div>
    </div>
  );
};
